export enum JOB_STATUS_CODE {
  CREATED = 'CREATED',
  WAITING = 'WAITING',
  COMPLETED = 'COMPLETED',
  TIMEDOUT = 'TIMEDOUT',
  FAILED = 'FAILED'
}

export enum LOCATION_TYPES_CODE {
  ROAD = 'Road Reserve',
  PRIVATE = 'Private',
  BOTH = 'Both'
}

export type ViewingEmail = {
  seqNo?: number;
  assetOwnerContact?: string;
  name: string;
  id: number;
  enquiryId?: number;
  bodies: any[];
  uploadedFiles: any[];
};

export type AutoRenew = {
  seqNo?: number;
  assetOwnerContact?: string;
  name: string;
  bodies: any[];
};

export type EditAutoRenew = {
  isEdit: boolean;
  isDuplicate: boolean;
  editId: number;
  enquiryId: number;
  autoRenew: boolean;
  autoRenewEvery: string;
  autoRenewUntil: string;
  completionDate: string;
};

export interface AutoRenewFormValues {
  autoRenew: boolean;
  autoRenewEvery: number;
  autoRenewUntil: string;
  jobEndDate: string;
}

export interface EnquiryEditFormValues {
  userReference: string;
  expireAt: string;
}

export interface AddAttachmentParams {
  enquiryId: number;
  file: File;
  presentationName: string;
  assetOwnerId?: number;
}
